// extracted by mini-css-extract-plugin
export var modal = "_gr-0";